import { getRoleGroupForRoles } from '../../views/ManageTeam/InviteRoleGroups'
import React, { ComponentType, PropsWithChildren } from 'react'
import { useGetRolesQuery } from '../../store/role/role'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import styled from 'styled-components'
import { getRoleDisplayName } from './utils'

export interface RolesProps {
  userRoleIds: string[]
  roleElement?: ComponentType<PropsWithChildren>
}

const RoleDiv = styled.div``

export const Roles: React.FC<RolesProps> = ({ userRoleIds, roleElement }) => {
  const accountId = useAppSelector(selectAccountId)
  const roleGroup = getRoleGroupForRoles(userRoleIds)
  const { data: roleData } = useGetRolesQuery({ accountId: accountId, pageRequest: { page: 0, size: 500 } })

  const RoleElement = roleElement ?? RoleDiv

  if (roleGroup) {
    return <RoleElement>{roleGroup.name}</RoleElement>
  }
  return (
    <div>
      {userRoleIds
        .map((roleId) => {
          const role = roleData?.data.find((role) => roleId === role.id)
          return role ? getRoleDisplayName(role) : roleId
        })
        .join(', ')}
    </div>
  )
}
